export const LOCALE_KEY = 'locale';
export const NO_LOGO_URL = '/assets/images/no_logo.png';
export const PAGE_LIMIT = 20;
export const INITIAL_PAGE_OFFSET = 0;
export const REQUEST_ID_HEADER = 'x-request-id';
export const TIYN_TENGE_SCALE_FACTOR = 100;
export const DAY_SECONDS = 86400;
export const TAB = 'tab';
export const NESTED_TAB = 'nested-tab';
export const MAX_LENGTH = 255;
